(function ($) {
    $('.woocommerce-shipping-methods__input-wrapper > input').on('change', function (){
        let that = $(this),
            list = that.parents('#shipping_method'),
            items = list.find('li')

        items.removeClass('active');
        that.parents('li').addClass('active');
    });

    $('body').on('click', '.js-checkout-step', function (e){
        e.preventDefault();

        let that = $(this),
            href = that.attr('href'),
            step = that.parents('.checkout-steps__item'),
            step_index = step.index()  + 1

        // add class on step item
        $('.checkout-steps__item:lt(' + step_index + ')').addClass('checkout-steps__item_prev');
        $('.checkout-steps__item:gt(' + step_index + ')').removeClass('checkout-steps__item_prev');

        // check current expand trigger or not
        if(that.is('.js-checkout-step_current')){
            step.removeClass('checkout-steps__item_prev');
        }

        // collapse content
        $('.checkout-steps__item-content').removeClass('active');
        $(href).addClass('active');

        console.log(step_index);
    });
})(jQuery);